import React from 'react'
import { Box, Divider, SvgIconTypeMap, Typography } from '@material-ui/core'
import useStyles from 'Components/Pages/Services/FormationDashboard/StatusTrackerTile/styles'
import { OverridableComponent } from '@material-ui/core/OverridableComponent'

type Props = {
  title: string
  Icon: OverridableComponent<SvgIconTypeMap<{}, 'svg'>>
  featured: boolean
  completed: boolean
}
const StatusTrackerTile = ({ title, Icon, featured, completed }: Props) => {
  const classes = useStyles({ featured, completed })
  const variant = featured ? 'h5' : 'h6'
  const iconClass = featured || completed ? 'featuredIcon' : 'standardIcon'
  return (
    <Box className={classes.card} p={3}>
      <Box pt={3} className={classes.iconContainer}>
        <Icon fontSize='inherit' className={classes[iconClass]} />
      </Box>
      <Box display='block' minHeight={50} className={classes.title}>
        <Typography variant={variant}>{title}</Typography>
      </Box>
      <Divider className={classes.divider} />
    </Box>
  )
}

export default StatusTrackerTile
